import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Icon, Table, ButtonGroup, IconButton } from 'rsuite'

export default function IncomeRecordFileTable({
  data = [],
  onPreview = () => {},
  onDownload = () => {},
  onDelete = () => {},
  deleteable = false,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  return (
    <>
      <Panel
        bordered
        collapsible
        defaultExpanded
        header={`เอกสารแนบประกอบ (จำนวน ${data?.length || 0} ไฟล์)`}
      >
        {data?.length > 0 &&
          data.map((item, index) => {
            return (
              <>
                <Row
                  style={{
                    borderStyle: 'none none groove none',
                    marginTop: 10,
                    borderColor: '#53535321',
                  }}
                  key={index}
                >
                  <Col lg={20} md={14} sm={24} xs={24} style={{ padding: 10 }}>
                    {`${index + 1}.  ${item?.label || item?.name}`}
                  </Col>
                  <Col
                    lg={4}
                    md={10}
                    sm={24}
                    xs={24}
                    style={{
                      textAlign: 'center',
                    }}
                  >
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        size="sm"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={(e) => onPreview(item)}
                        disabled={!item?.path}
                      />
                      <IconButton
                        appearance="ghost"
                        size="sm"
                        icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                        onClick={(e) => onDownload(item)}
                        disabled={!item?.path}
                      />
                      {deleteable && (
                        <IconButton
                          appearance="ghost"
                          size="sm"
                          className="rs-btn-ghost-cancel"
                          icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                          onClick={(e) => onDelete(item)}
                          disabled={!item?.path}
                        />
                      )}
                    </ButtonGroup>
                  </Col>
                </Row>
              </>
            )
          })}
      </Panel>

      <br />

      {/* <Table autoHeight wordWrap bordered data={data}>
        <Column minWidth={300} flexGrow={1}>
          <HeaderCell>เอกสารแนบประกอบ</HeaderCell>
          <Cell dataKey="label" />
        </Column>

        <Column width={150} align="center" fixed="right">
          <HeaderCell></HeaderCell>
          <Cell>
            {(rowData, index) => {
              return (
                <ButtonGroup>
                  <IconButton
                    appearance="ghost"
                    icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                    onClick={(e) => onPreview(rowData)}
                    disabled={!rowData?.path}
                  />
                  <IconButton
                    appearance="ghost"
                    icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                    onClick={(e) => onDownload(rowData)}
                    disabled={!rowData?.path}
                  />
                  {deleteable && (
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-cancel"
                      icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                      onClick={(e) => onDelete(rowData)}
                      disabled={!rowData?.path}
                    />
                  )}
                </ButtonGroup>
              )
            }}
          </Cell>
        </Column>
      </Table> */}
    </>
  )
}
